import { useState } from "react";
import {
  Button,
  SimpleForm,
  PasswordInput,
  useNotify,
  useRefresh
} from "react-admin";
import { Dialog, DialogActions, DialogContent, Stack } from "@mui/material";
import { required, minLength } from "react-admin";

const PasswordUpdateDialog = ({ open, onClose, record }) => {
  const [isLoading, setIsLoading] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();
  const token = JSON.parse(localStorage.getItem('token'));

  const handleSubmit = async (data) => {
    if (data.newPassword !== data.confirmPassword) {
      notify('Passwords do not match', { type: 'error' });
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_URL}/admin/users/${record.id}/password`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ newPassword: data.newPassword })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update password');
      }

      const result = await response.json();
      
      notify(result.message || 'Password updated successfully', { type: 'success' });
      refresh();
      onClose();
    } catch (error) {
      notify(`Error updating password: ${error.message}`, { type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <SimpleForm
        onSubmit={handleSubmit}
        toolbar={false}
      >
        <DialogContent>
          <Stack spacing={2}>
            <h2>Update Password for {record?.name}</h2>
            <PasswordInput
              source="newPassword"
              label="New Password"
              fullWidth
              validate={[required(), minLength(6)]}
            />
            <PasswordInput
              source="confirmPassword"
              label="Confirm Password"
              fullWidth
              validate={[required()]}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            label="Cancel"
            onClick={onClose}
            disabled={isLoading}
          />
          <Button
            type="submit"
            label={isLoading ? "Updating..." : "Update Password"}
            variant="contained"
            disabled={isLoading}
          />
        </DialogActions>
      </SimpleForm>
    </Dialog>
  );
};

export default PasswordUpdateDialog;